import { Form } from '@mairistem/composants';
import { Icon, Panel } from '@mairistem/finances-utils';
import React from 'react';
import { Sens } from '@mairistem/comptabilite';
import PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import './InformationsRattachementComponent.less';

const MandatAnnulantTitreAnterieurComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (_e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group className="panelRow">
          <Form.Input
            name="exerRattachement"
            label="Exercice"
            value={data?.exerRattachement}
            title={data?.exerRattachement}
            onChange={handleChange}
            width={8}
            input={{
              maxLength: 4,
            }}
          />
          <Form.Input
            name="pieceOrigine"
            label={`N° du ${data?.sens === Sens.RECETTE ? 'mandat' : 'titre'} annulé/réduit`}
            value={data?.pieceOrigine}
            title={data?.pieceOrigine}
            onChange={handleChange}
            width={8}
          />
        </Form.Group>
        <Form.Group className="panelRow">
          <Form.Input
            name="idLigneOriginePes"
            label={`N° de la ligne de ${data?.sens === Sens.RECETTE ? 'mandat' : 'titre'}`}
            value={data?.idLigneOriginePes}
            title={data?.idLigneOriginePes}
            onChange={handleChange}
            width={14}
          />
          <Form.Input
            control={Icon}
            name="caret down"
            size="large"
            circular
            width={2}
            className="panelButton"
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default MandatAnnulantTitreAnterieurComponent;
